import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const DivisionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [division, setDivision] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDivision = async () => {
      try {
        const data = await api.getFirstThierProgramById({ id });
        setDivision(data);
      } catch (error) {
        console.error('Error fetching division:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchDivision();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  if (!division) {
    return (
      <div className="container py-4 text-center">
        <div className="text-muted mb-3">Data divisi tidak ditemukan.</div>
        <Link to="/division" className="btn btn-primary rounded-pill btn-sm px-3">
          Kembali ke Daftar Divisi
        </Link>
      </div>
    );
  }

  const subPrograms = division.secondProgram || [];

  return (
    <div className="container py-4">
      {/* Back Button */}
      <div className="mb-3">
        <button
          type="button"
          className="btn btn-white btn-sm rounded-circle shadow-sm border bg-white text-dark d-inline-flex align-items-center justify-content-center"
          style={{ width: '38px', height: '38px' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left fs-5"></i>
        </button>
      </div>

      {/* Header */}
      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-4">
          <h4 className="fw-bold text-primary mb-2">{division.name}</h4>
          <p className="text-secondary mb-0">{division.description || <em>Tidak ada deskripsi divisi.</em>}</p>
          <div className="mt-3">
            <span className={`badge rounded-pill ${division.status ? 'bg-success' : 'bg-secondary'}`}>
              {division.status ? 'Aktif' : 'Nonaktif'}
            </span>
          </div>
        </div>
      </div>

      {/* Responsible Section */}
      <div className="mb-4">
        <h6 className="fw-bold mb-3">
          <i className="bi bi-person-badge text-primary me-2"></i>
          Manajer / Penanggung Jawab Divisi
        </h6>

        {division.responsible && division.responsible.length > 0 ? (
          <div className="row g-3">
            {division.responsible.map((r) => (
              <div className="col-md-4" key={r.id}>
                <div
                  className="card shadow-sm border-0 rounded-3 h-100 border-start border-4 border-primary"
                >
                  <div className="card-body py-3">
                    <h6 className="fw-semibold mb-1">{r.fullName}</h6>
                    <span className="badge rounded-pill text-bg-primary">
                      Aktif memimpin
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-muted small border rounded-3 p-3 bg-light">
            Belum ada manajer yang ditugaskan untuk divisi ini.
          </div>
        )}
      </div>

      {/* Programs Section */}
      <div>
        <h6 className="fw-bold mb-3">
          <i className="bi bi-journal-text text-primary me-2"></i>
          Program (Second Tier) di bawah Divisi ini
        </h6>

        {subPrograms.length > 0 ? (
          <div className="row g-3">
            {subPrograms.map((program) => (
              <div className="col-md-6 col-lg-4" key={program.id}>
                <div className="card border-0 shadow-sm rounded-3 h-100">
                  <div className="card-body d-flex flex-column justify-content-between p-3">
                    <div>
                      <h6 className="fw-bold text-primary mb-1">
                        {program.name}
                      </h6>
                      <p className="text-muted small mb-2">
                        ID: {program.id}
                      </p>
                    </div>

                    <div className="mt-auto border-top pt-2 small text-secondary">
                      <i className="bi bi-person me-1"></i>
                      Penanggung Jawab: {program.responsible || '-'}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-muted small border rounded-3 p-3 bg-light">
            Belum ada program (Second Tier) terdaftar di bawah divisi ini.
          </div>
        )}
      </div>
    </div>
  );
};

export default DivisionDetail;
